import black from './black.png';
import blue from './blue.png';
import brown from './brown.png';
import champagne from './champagne.png';
import diamonds from './diamonds.png';
import gray from './gray.png';
import green from './green.png';
import pink from './pink.png';
import purple from './purple.png';
import red from './red.png';
import shell from './shell.png';
import silver from './silver.png';
import white from './white.png';
import yellow from './yellow.png';

const colorIcons = {
  black,
  blue,
  brown,
  champagne,
  diamonds,
  gray,
  green,
  pink,
  purple,
  red,
  shell,
  silver,
  white,
  yellow
};

export default colorIcons;
